import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaFacebook, FaInstagram, FaYoutube, FaEnvelope } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section about">
            <h3>À propos de Conclave 2025</h3>
            <div className="footer-logo">
              <img src="/images/logo.png" alt="Conclave 2025" className="logo-img-footer" />
            </div>
            <p>Votre source d'information sur l'élection du prochain pape au Vatican.
            </p>
          </div>
          
          <div className="footer-section links">
            <h3>Liens rapides</h3>
            <ul>
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/cardinaux">Annuaire des Cardinaux</Link></li>
              <li><Link to="/papabili">Classement des Papabili</Link></li>
              <li><Link to="/conclave">Conclave Virtuel</Link></li>
            </ul>
          </div>
           <div className="footer-section contact">
            <h3>Contact</h3>
            <p>
			  Pour toute question ou suggestion concernant ce site, n'hésitez pas à nous contacter.</p>
             <p> <FaEnvelope /> bonjour@conclave2025.fr</p>
            

          </div>
        </div>
        
        <div className="footer-bottom">
          <p>
            &copy; {currentYear} Conclave2025.fr — Tous droits réservés
          </p>
          <div className="footer-legal">
            <a href="/mentions-legales">Mentions légales</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;